import React from 'react'

const CodeOfConduct = () => {
 return (
  <div className='max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-lg font-sans leading-relaxed'>
   <div className='relative mb-6'>
    <div className='absolute right-0 top-0'>
     <img
      src='/media/icons/bayer.svg'
      alt='Bayer Logo'
      className='h-12 md:h-16 lg:h-16 w-auto'
     />
    </div>

    <h1 className='text-lg font-bold text-center mb-1 pr-10 md:pr-16'>
     APPENDIX – COCFA
    </h1>

    <h2 className='text-base md:text-xl font-semibold text-center border-b-2 border-gray-200 pb-3 pr-10 md:pr-16'>
     CODE OF CONDUCT FOR ASSOCIATES
    </h2>
   </div>

   <p className='mb-4'>
    Bayer’s quest for competitive excellence begins and ends
    with its commitment towards not only compliance with law
    but also ethical principles in order to maintain its
    high business standards. Bayer has devised the following
    Code of Conduct which is applicable to the key stake
    holders such as manufacturers, suppliers, marketers,
    dealers, distributors, agents, transporters,
    consultants, customers, clients and service providers
    and all other business partners of Bayer (hereinafter
    referred to as “Associates”). While Bayer appreciates
    the internal guidelines of all Associates and its
    compliance, Bayer also desires that the Associates
    should fully understand its Code of Conduct in true
    spirit of its intent and words and strictly comply with
    the same.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    NO CONFLICT OF INTEREST - Separation of corporate &
    personal interests
   </h3>
   <p className='mb-4'>
    Conflict of interest arises when the interest or
    benefits of one person or entity conflict with the
    interests or benefits of Bayer. Any business
    relationship with Bayer must be formed on the basis of
    objective criteria such as price, quality, reliability &
    product suitability.
   </p>
   <p className='mb-4'>
    Associates must disclose any existing or potential
    conflict of interest while entering into or during the
    course of any arrangement with Bayer.
   </p>
   <p className='mb-6'>
    Associates must not influence business dealing by
    offering inappropriate gifts / entertainment to
    employees of Bayer.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    COMMITMENT TO FAIR COMPETITION - No Antitrust violations
   </h3>
   <p className='mb-4'>
    Bayer prohibits any actions, informal talks or
    agreements which intend to restrict competition. Bayer
    expects the Associates to appreciate Bayer’s concerns
    for fair competition and ensure that no antitrust
    violations take place in their dealing with Bayer.
   </p>
   <p className='mb-4'>
    Bayer forbids collusion among competitors and
    anticompetitive arrangements among suppliers and
    customers. Bayer and the Associates shall exhibit full
    transparency in their dealings with each other in order
    to strictly follow the principles of fair competition.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    INTEGRITY IN BUSINESS DEALINGS - No corrupt practices
   </h3>
   <p className='mb-4'>
    Bayer has ZERO TOLERANCE towards Corruption. No amount
    of potential additional revenues can justify illegal
    business practices and hence, the Associates must not
    offer or accept an advantage with the intention to do
    something dishonest, illegal or to breach trust.
   </p>
   <p className='mb-6'>
    Bayer competes solely on an honest, objective basis and
    does not make unethical business dealings. Bayer
    employees and the Associates must not attempt to
    unlawfully influence business partners, government
    authorities or public servants through favours or other
    advantages which are construed to be corrupt practices.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    PRINCIPLE OF SUSTAINABILITY - No risks for human health
    and environment
   </h3>
   <p className='mb-4'>
    Bayer acknowledges its duty towards sustainable
    development and helps in meeting the economic,
    ecological and social needs of the present and future
    generations. All its Associates shall also provide its
    employees with a safe and healthy workplace in
    compliance with all applicable laws and regulations.
   </p>
   <p className='mb-6'>
    Associates shall support environmental protection,
    judicious consumption of energy and raw materials in
    production and also minimisation of the hazardous impact
    of the development, production, use and disposal of any
    products and services on the ecological environment.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    PROTECTION OF HUMAN RIGHTS - Healthy working environment
   </h3>
   <p className='mb-4'>
    Bayer strictly complies with all prohibitions on
    engagement of child labour. Associates must prohibit
    employment of child labour and fully comply with the
    provisions of applicable factory / labour laws.
   </p>
   <p className='mb-4'>
    Bayer does not tolerate any behavior that might harass,
    disrupt or interfere with the ability of a person.
    Sexual harassment in any form is totally intolerable.
    There shall be no use of abusive or offensive language.
    Associates shall not use any forced or involuntary or
    bonded labour.
   </p>
   <p className='mb-6'>
    Bayer provides equal opportunity to all its employees
    and treats them with respect and dignity. Associates
    shall not adopt discriminative policies on the basis of
    race, religion, age, nationality, social or ethnic
    origin, gender, disability, political opinion etc.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    IP RIGHTS & CONFIDENTIALITY - Protecting and respecting
    the legal rights
   </h3>
   <p className='mb-4'>
    The results of Bayer’s scientific research and technical
    development work are extremely valuable assets. Bayer is
    committed to protect the fruits of its own endeavours
    and respecting the legally recognized rights of others.
    Associates shall respect the intellectual property
    rights of Bayer including its patents, trademarks,
    copyrights, proprietary information and trade secrets
    and shall not use the same unless specifically
    authorized by Bayer in this regard.
   </p>
   <p className='mb-6'>
    Associates must treat any proprietary or confidential
    information of Bayer as highly confidential and protect
    business data against unauthorized access. Care should
    be taken to avoid any unintentional transfer of
    confidential information or infringement of intellectual
    property rights through negligent handling of the same.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    PROPER RECORDS & INFORMATION - Transparent reporting &
    communication
   </h3>
   <p className='mb-4'>
    Bayer expects its Associates to maintain accurate
    records and not to suppress or distort any material
    facts. Associates must maintain documents and records as
    per the applicable legal standards and preserve the same
    so long as the same are required under the relevant
    statutory provisions.
   </p>
   <p className='mb-6'>
    Bayer propagates transparency in all its dealings and is
    fully accountable to the appropriate authorities.
    Associates responsible for dealing with any statutory
    authorities should communicate information completely,
    correctly and in a timely manner.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    UPHOLDING COMMERCIAL LAWS - No export-import violation
   </h3>
   <p className='mb-4'>
    Bayer is committed to uphold all domestic and
    international commercial and trade laws. Bayer supports
    the efforts of the international community to prevent
    the manufacture and proliferation of chemical,
    biological and nuclear weapons.
   </p>
   <p className='mb-6'>
    All Associates are required to observe the restrictions
    and bans on domestic and international trade in listed
    goods, technologies and services. All Associates must
    also respect the trade bans and restrictions that are
    part of international embargos and efforts to combat
    terrorism.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    DATA PRIVACY - Protect and secure personal data
   </h3>
   <p className='mb-6'>
    Bayer strictly adheres to the laws designed to protect
    and secure the privacy and confidentiality of
    information about individuals. Associates receiving or
    holding individually identifiable personal data
    including sensitive personal data of the employees,
    customers, or any other individual of or on behalf of
    Bayer, should take appropriate technical, physical and
    organizational/administrative measures to protect such
    data and use it only Purpose of Services mentioned in
    the scope. All Associates must take necessary steps to
    avoid unlawful, unintentional or accidental leakage,
    breach or access of such data and immediately report to
    the Company if such incident occurs.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    Reporting Violation
   </h3>
   <p className='mb-6'>
    Violation of this Code of Conduct or any apprehension
    thereof shall be reported forthwith to the concerned
    Bayer representative so as to enable him to initiate
    suitable action in that regard.
   </p>

   <h3 className='text-lg font-semibold mt-6 mb-2 border-b border-gray-300 pb-2'>
    Contact for Further Information
   </h3>
   <p className='mb-6'>
    For any queries, concerns or clarification on this Code
    of Conduct, the Associates are requested to contact the
    concerned Bayer representative or Bayer’s Legal
    Department at its Registered Office.
   </p>

   <p className='text-gray-500 italic mt-6'>
    Version as of 01.02.2020
   </p>
  </div>
 )
}

export default CodeOfConduct
const CodeOfConductWrapper = () => {
 return <CodeOfConduct />
}

export {CodeOfConductWrapper}
